import { resolveNewPerspectiveFromTransitionFilters } from "../../../utils/transitions";
import itemFactory from "./ItemFactory";
export default (({
  options,
  newFilters
}) => itemFactory({
  options,
  newFilters,
  newPerspective: resolveNewPerspectiveFromTransitionFilters(newFilters)
}));